import LoadingIndicator, { initLoadingIndicatorsByName } from '../loadingindicator';
import { isMapMode } from '../maps/util';
import { countFilters } from './filter-count';

class InlinePropertySearchForm {
    _form: HTMLFormElement;
    _keepCount: boolean;
    _keepCountEndpoint: URL;
    _loadingIndicators: Array<LoadingIndicator> = [];

    constructor( form: HTMLFormElement ) {
        this._form = form;
        this.init();
    }

    init(): void {
        this._updateFilterCountBasedState();

        document.addEventListener( 'twc:update-filter-count-badges', this._updateFilterCountBasedState.bind( this ) );

        document.addEventListener( 'twc:mapsearch:initialising', this._startLoading.bind( this ) );

        document.addEventListener( 'twc:mapsearch:initialised', this._stopLoading.bind( this ) );

        const autoTriggerSubmitSelects = this._form.querySelectorAll( '[name=maxprice],[name=beds],[name=order]' );

        autoTriggerSubmitSelects.forEach( ( input ) => {
            input.addEventListener( 'change', () => {
                if ( isMapMode() ) {
                    this._form.dispatchEvent( new CustomEvent( 'twc:mapsearch:form-submit', { bubbles: true } ) );
                    return;
                }
                this._startLoading();

                this._form.submit();
            } );
        } );

        this._loadingIndicators = initLoadingIndicatorsByName( 'inline-search-form' );

        this._form.addEventListener( 'submit', ( event ) => {
            if ( isMapMode() ) {
                return;
            }

            this._startLoading();
        } );

        window.addEventListener( 'pageshow', ( event: PageTransitionEvent ) => {
            if ( event.persisted ) {
                this._stopLoading();
            }
        } );
    }

    _updateFilterCountBasedState(): void {
        const filterCounts = countFilters( this._form );

        document.querySelectorAll<HTMLElement>( '.filtercount[data-type="all"]' ).forEach( ( counter: HTMLElement ) => {
            counter.innerHTML = filterCounts.property.count.toString();

            if ( filterCounts.property.count === 0 ) {
                counter.classList.add( 'd-none' );
            } else {
                counter.classList.remove( 'd-none' );
            }
        } );
    }

    _startLoading(): void {
        this._loadingIndicators.forEach( ( indicator ) => indicator.show() );
    }

    _stopLoading(): void {
        this._loadingIndicators.forEach( ( indicator ) => indicator.hide() );
    }
}

export default InlinePropertySearchForm;
